import React from 'react';
import { NumericFormat } from 'react-number-format';

interface CustomProps {
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  name: string;
}

const NumberFormatCustom = React.forwardRef<JSX.Element, CustomProps>(
  function NumberFormatCustom(props, ref) {
    const { onChange, ...other } = props;

    return (
      <NumericFormat
        {...other}
        getInputRef={ref}
        onValueChange={(values) => {
          onChange({
            target: {
              name: props.name,
              value: values.value,
            },
          } as React.ChangeEvent<HTMLInputElement>);
        }}
        thousandSeparator
        decimalScale={2}
        valueIsNumericString
        inputMode="decimal"
        prefix="$"
        allowNegative={false}
      />
    );
  }
);

export default NumberFormatCustom;
